import styled from 'styled-components';

export default styled.section``;

export const WorkStatusStyled = styled.div`
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 53px;
  .body {
    height: auto;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: var(--box-shadow);
    padding-bottom: 15px;
    position: relative;
    // 2023/10/10 Leading Win 作業員シフト表廃止対応 start
    // margin-top: 84px;
    margin-top: 0px;
    // 2023/10/10 Leading Win 作業員シフト表廃止対応 end
  }
  // 2023/10/10 Leading Win 作業員シフト表廃止対応 start
  .bobody {
    height: auto;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: var(--box-shadow);
    padding-bottom: 15px;
    position: relative;
    margin-top: 84px;
  }
  // 2023/10/10 Leading Win 作業員シフト表廃止対応 end
  .header-tab {
    width: 100%;
    padding-top: 14px;
    padding-left: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }
  .lock-status-container {
    position: fixed;
    z-index: 98;
    top: 64px;
    left: 0;
    right: 0;
    padding-top: 28px;
    padding-bottom: 24px;
    padding-right: 32px;
    padding-left: 32px;
    width: 100%;
    background-color: #f7f7f7;
  }
  .box-worker-status {
    display: flex;
    flex-direction: column;
    padding: 23px 32px 0 32px;
  }
  .header-box {
    margin-bottom: 14px;
  }
  .text-1 {
    margin-right: 16px;
    font-weight: 600;
    font-size: 16px;
    color: #000000;
  }
  .ant-table-tbody {
    box-shadow: none !important;
  }
  .ant-table-thead {
    > tr {
      > th {
        border-bottom: solid 1px rgba(0, 0, 0, 0.05) !important;
      }
    }
  }
  .box-sling-tool {
    display: flex;
  }
  .item-sling-tool {
    display: flex;
    width: 202px;
    height: 48px;
    justify-content: space-between;
    align-items: center;
    border-bottom: solid 1px rgba(0, 0, 0, 0.05);
    margin-right: 19px;
    .text-item-sling-tool {
      padding-left: 16px;
      height: 24px;
      border-left: solid 1px rgba(0, 0, 0, 0.05);
      display: flex;
      align-items: center;
    }
  }
  .box-test-scaffold {
    width: 50%;
  }
  .box-list-test-scaffold {
    margin-top: 14px;
  }
  .item-test-scaffold {
    white-space: break-spaces;
    display: flex;
    justify-content: space-between;
    min-height: 48px;
    align-items: center;
    border-bottom: solid 1px rgba(0, 0, 0, 0.05);
    .text-item-test-scaffold {
      padding-left: 16px;
      border-left: solid 1px rgba(0, 0, 0, 0.05);
      white-space: break-spaces;
    }
  }
  .box-scaffold {
    display: flex;
    padding-top: 23px;
  }
  .scaffold-left {
    padding-left: 32px;
    padding-right: 16px;
  }
  .scaffold-right {
    padding-left: 16px;
    padding-right: 32px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .box-button-submit {
    display: flex;
    justify-content: flex-end;
  }
  .button-submit {
    display: flex;
    flex-direction: column;
    align-items: center;

    .title-button {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 8px;
    }
  }
  .button-return {
    margin-left: 9px;
    button {
      background: linear-gradient(149.45deg, #3c82c0 0%, #1c4b8c 100%);
      color: white !important;
      &:disabled {
        background: #fff;
        border: 1px solid var(--border-color-base) !important;
        color: var(--border-color-base) !important;
        &.hide {
          border: 1px solid #cccccc !important;
          color: #808080 !important;
        }
      }
    }
  }
  .button-left {
    margin-left: 9px;
    button {
      background: linear-gradient(149.45deg, #3c82c0 0%, #1c4b8c 100%);
      color: white !important;
      &:disabled {
        background: #fff;
        border: 1px solid var(--border-color-base) !important;
        color: var(--border-color-base) !important;
        &.hide {
          border: 1px solid #cccccc !important;
          color: #808080 !important;
        }
      }
    }
  }
  .button-right {
    margin-left: 9px;
    button {
      background: linear-gradient(149.45deg, #3c82c0 0%, #1c4b8c 100%);
      color: var(--white);
      border: unset;
      font-weight: 600;
      :disabled {
        border: 1px solid #cccccc;
        color: #808080;
        font-weight: 600;
        background: unset;
        &.hide {
          border: 1px solid #cccccc !important;
          color: #808080 !important;
        }
      }
    }
  }
  .content-edit {
    border: solid 1px rgba(0, 0, 0, 0.25);
    text-align: justify;
    word-break: break-all;
  }
`;

export const TabStyled = styled.div`
  width: calc(100vw - 300px);
  display: flex;
  flex-wrap: wrap;

  .ant-tabs-tab {
    color: rgba(0, 0, 0, 0.5);
  }
  .ant-tabs-top > .ant-tabs-nav {
    margin: 0;
  }
  .ant-tabs-top > .ant-tabs-nav::before {
    border-bottom: none;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: rgb(0, 0, 0);
  }
  .ant-tabs-tab.ant-tabs-tab-active::after {
    content: '';
    width: 100%;
    position: absolute;
    background: linear-gradient(149.45deg, rgb(60, 130, 192) 0%, rgb(28, 75, 140) 100%);
    height: 4px;
    bottom: 0;
  }

  .tabTrue {
    width: 120px;
    height: 56px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 9px;
    color: #000000;
    .line {
      width: 120px;
      height: 4px;
      background: linear-gradient(149.45deg, #3c82c0 0%, #1c4b8c 100%);
    }
  }
  .header {
    font-weight: 600;
    font-size: 16px;
    width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .title {
    font-size: 12px;
  }
  .tabFalse {
    width: 120px;
    height: 56px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 9px;
    color: rgba(0, 0, 0, 0.5);
  }
`;

type PropsSubmit = {
  color: string;
};

export const SubmitStyled = styled.div<PropsSubmit>`
  height: 20px;
  width: 80px;
  min-width: 80px;
  border-radius: 4px;
  background-color: ${(props) => props.color};
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type PropsPointRisk = {
  checked: boolean;
};

export const PointRiskStyled = styled.div<PropsPointRisk>`
  color: ${(props) => (props.checked ? '#E65050' : '')};
  font-weight: ${(props) => (props.checked ? '800' : '400')};
  min-width: 70px;
`;

type PropsCheckTool = {
  status: number | string;
};

export const CheckToolStyled = styled.div<PropsCheckTool>`
  height: 24px;
  width: 24px;
  min-width: 24px;
  display: flex;
  align-items: center;
  padding-top: 2.5px;
  justify-content: center;
  line-height: 24px;
  font-weight: 600;
  border-radius: 2px;
  /* background-color: ${(props) => (props.status === 3 ? '#FFFFFF' : '')}; */
  background-color: ${(props) => (props.status === 0 ? '#FFFFFF' : '')};
  background-color: ${(props) => (props.status === 1 ? '#69B362' : '')};
  color: ${(props) => (props.status === 0 ? '#333333' : '#FFFFFF')};
  color: ${(props) => (props.status === 3 && 'black!important') || ''};
`;
